<script setup lang="ts">
import { type IconDefinition, faArrowRight } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { GpBtn } from '@gportal/uikit';

const { label = 'continue', icon = faArrowRight } = defineProps<{
  label?: string;
  icon?: IconDefinition;
}>();

const emit = defineEmits<{
  click: [];
}>();
</script>

<template>
  <GpBtn class="tw-block tw-w-1/3" label="Continue" @click="emit('click')">
    {{ label }}

    <FontAwesomeIcon class="tw-ml-2" :icon="icon" />
  </GpBtn>
</template>

<style scoped></style>
